import { actionStatus } from '~/features/deviceReports/constants/actionStatus';

export const actionStatusSettings = {
    [actionStatus.SUCCESS]: {
        badge: 'text-success uikit-icon icon-ok-sign ',
        label: 'intl-msg:report.successful'
    },
    [actionStatus.FAILURE]: {
        badge: 'text-danger uikit-icon icon-remove-sign',
        label: 'intl-msg:report.failed',
    },
    [actionStatus.ONGOING]: {
        badge: 'text-warning uikit-icon icon-question-sign',
        label: 'intl-msg:report.notFinished',
    },
    [actionStatus.REBOOT_PENDING]: {
        label: 'intl-msg:report.state.isRebootPending.label',
        message: 'intl-msg:report.state.isRebootPending.message',
        badge: 'text-warning uikit-icon icon-time',
    },
};
